import { Box, Flex, Switch, Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormInput,
  FormLabel,
  FormTextarea,
} from 'src/components/Common/FormComponent';
import { EnableDisableStatus } from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

function NotifyUser(props: {
  status: EnableDisableStatus;
  subject: string;
  message: string;
  setStatus: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setSubject: (subject: string) => void;
  setMessage: (message: string) => void;
}) {
  const { t } = useTranslation();
  const { status, subject, message, setStatus, setSubject, setMessage } = props;
  useWhyDidYouUpdate('NotifyUser', props);
  return (
    <Box>
      <Flex mb="24px" alignItems="center">
        <FormLabel
          label={t('common.label.notifyUser')}
          width="160px"
          withColon
        />
        <Switch
          checked={!!status}
          value={status}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setStatus(e);
          }}
        />
        <Text ml="2x">
          {status ? t('common.label.on') : t('common.label.off')}
        </Text>
      </Flex>
      <Flex mb="24px">
        <FormLabel label={t('common.label.subject')} width="160px" withColon />
        <FormInput
          placeholder={t('policy.label.subjectDesc')}
          width="701px"
          value={subject}
          maxLength={200}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSubject(e.target.value);
          }}
          disabled={!status}
        />
      </Flex>
      <Flex mb="24px">
        <FormLabel label={t('common.label.message')} width="160px" withColon />
        <FormTextarea
          placeholder={t('policy.label.messageDesc')}
          width="701px"
          height="137px"
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          disabled={!status}
        />
      </Flex>
    </Box>
  );
}

export default React.memo(NotifyUser);
